import { differenceInMinutes } from "date-fns";
import { AltTransIncidentArrival } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC, useMemo } from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { getSemanticsForDelay } from "shared/utils/semantics";
import styled, { css } from "styled-components";

// TODO: Support more colours?
const Wrapper = styled.div<{ $backgroundColor: string; $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 16px;
  width: 44px;
  border-radius: 1px 12px 12px 1px;

  font-size: 12px;
  font-weight: 700;
  line-height: 16px;

  ${({ $backgroundColor, $color }) => css`
    background-color: ${$backgroundColor};
    color: ${$color};
  `}
`;

type TrainIndicatorProps = {
  trainNumber: number | string;
  incidentArrival?: AltTransIncidentArrival;
  disabled?: boolean;
};

export const TrainIndicator: FC<TrainIndicatorProps> = ({
  trainNumber,
  incidentArrival,
  disabled = false,
}) => {
  const semantics = useMemo<Semantics>(() => {
    if (!incidentArrival) return "success";

    const { scheduledTime, estimatedTime, actualTime } = incidentArrival;
    const bestCurrentTime = actualTime ?? estimatedTime;
    const delay =
      scheduledTime && bestCurrentTime
        ? differenceInMinutes(bestCurrentTime, scheduledTime)
        : 0;

    return getSemanticsForDelay(delay);
  }, [incidentArrival]);

  const theme = useThemeSemantic(semantics);

  return (
    <Wrapper
      $backgroundColor={
        disabled ? theme.colorIconDisabled : theme.colorSemantic
      }
      $color={disabled ? theme.colorTextBrand : theme.colorSemanticTextTertiary}
    >
      {trainNumber}
    </Wrapper>
  );
};
